import {
  API_STATES
} from '@/helpers'
  
const state = {
  hotFloorDataGetState : API_STATES.NOT_REQUESTED,
  hotFloorDataGetError : null,
  hotFloorData         : {
    hourlyStatsWeek           : {},
    predictedTransactionsWeek : 0
  }
}

export default state
  